import { css } from '@emotion/core'
import { mediumUp, largeUp } from 'Utils'

export default ({ theme: { typography, colors } }) => {
  return css`
    @media ${mediumUp} {
    }
    @media ${largeUp} {
    }
  `
}
